import React, { useEffect, useRef } from "react";
import { useYandexMap } from "shared/helper/updateObject";
import { Call, Location, Message, Printer } from "shared/components/Icons";
import Pasha from "shared/media/phCard/phLogo.png";
import Hub from "shared/media/phCard/hubLogo.png";
import GreenMarker from "./marker.png";
import "./Card.scss";

const PhCard = ({ lon, lan, email, fax, phone, location, title }) => {
  const mapRef = useRef(null);
  const isReady = useYandexMap();

  const images = [Pasha, Hub];

  useEffect(() => {
    if (!isReady || !window.ymaps) return;

    const map = new window.ymaps.Map(mapRef.current, {
      center: [lan, lon],
      zoom: 9,
      controls: ["fullscreenControl"],
    });

    const placemark = new window.ymaps.Placemark(
      [lan, lon],
      {},
      {
        iconLayout: "default#image",
        iconImageHref: GreenMarker,
        iconImageSize: [30, 45],
      },
    );

    map.geoObjects.add(placemark);

    return () => {
      map.destroy();
    };
  }, [isReady, lan, lon]);

  return (
    <div className="phCard">
      <div className="phCardTop">
        <div className="innerDiv">
          <div className="image">
            {images.map((src, i) => (
              <img key={i} alt="logo" className="cardImg" src={src} />
            ))}
          </div>

          <div className="map">
            {!isReady && <div>Loading map...</div>}
            <div ref={mapRef} style={{ width: "100%", height: "100%" }} />
          </div>
        </div>

        <h1>{title}</h1>

        <ul className="phCardTopUl list-unstyled">
          {[
            { icon: <Location />, text: location },
            { icon: <Message />, text: email },
            phone && { icon: <Call />, text: phone },
            fax && { icon: <Printer />, text: fax },
          ]
            .filter(Boolean)
            .map((item, i) => (
              <li key={i} className="phCardTopUlLi">
                <div className="svgDiv">{item.icon}</div>
                <span>{item.text}</span>
              </li>
            ))}
        </ul>
      </div>
    </div>
  );
};

export default PhCard;
